<script setup>
import { defineProps, defineEmits} from "vue";
import LinhaDeDadosResumo from "./LinhaDeDadosResumo.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dados",
    "dado",
    "dadoOriginal",
    "gerandoPagamentos",
]);

const emits = defineEmits([
    "update:alteraVisualizandoDado",
    "update:alteraLiberandoDado",
    "update:alteraAprovandoDado",
    "update:alteraGerandoPagamentos",
    "update:alteraBaixandoDado",
]);

//==================================================================//
//==================== Altera Visualizando Dado ====================//
//==================================================================//

const alteraVisualizandoDado = (update = {})=>{

    emits('update:alteraVisualizandoDado',update);

};

//==================================================================//
//====================== Altera Liberando Dado =====================//
//==================================================================//

const alteraLiberandoDado = (update = {})=>{

    emits('update:alteraLiberandoDado',update);

};

//==================================================================//
//====================== Altera Aprovando Dado =====================//
//==================================================================//

const alteraAprovandoDado = (update = {})=>{

    emits('update:alteraAprovandoDado',update);

};

//==================================================================//
//=================== Altera Gerando Pagamento =====================//
//==================================================================//

const alteraGerandoPagamentos = (update = {})=>{

    emits('update:alteraGerandoPagamentos',update);

};

//==================================================================//
//======================= Altera Baixando Dado =====================//
//==================================================================//

const alteraBaixandoDado = (update = {})=>{

    emits('update:alteraBaixandoDado',update);

};

</script>

<template>

    <div class="c-table__row-group">

        <LinhaDeDadosResumo
            :dados="props?.dados"
            :dado="dado"
            :dadoOriginal="props?.dadoOriginal"
            :gerandoPagamentos="props?.gerandoPagamentos"
            @update:alteraVisualizandoDado="alteraVisualizandoDado"
            @update:alteraLiberandoDado="alteraLiberandoDado"
            @update:alteraAprovandoDado="alteraAprovandoDado"
            @update:alteraGerandoPagamentos="alteraGerandoPagamentos"
            @update:alteraBaixandoDado="alteraBaixandoDado"
        ></LinhaDeDadosResumo>

    </div>

</template>

<style scoped>

/*==================================================================*/
/*============================ Table ===============================*/
/*==================================================================*/

.c-table__row-group{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>